import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { updateSelectedEntity } from '../../redux/slices/dtStudioSlice'
import ListOfEntities from './ListOfEntities'
import { getEntities } from '../../redux/slices/navSlice'
import { EntityType } from './interfaces'
import { Box } from '@mui/material'
import { preserveExpandedState } from '../../utils/EntityUtils'

const DTLeftPane: React.FC = () => {
    const [entityTypes, setEntityTypes] = useState<EntityType[]>([])
    const org = useAppSelector((state) => state.org.org)
    const navList = useAppSelector((state) => state.nav.navList)
    const orgId = org?.id ? org?.id : ''
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (navList?.length) {
            const initialSelectedEntity = navList.length ? navList[0] : ''
            dispatch(updateSelectedEntity(initialSelectedEntity))
        }
        // const updatedNavList = getPreservedValues(navList)
        const updatedNavList = preserveExpandedState(entityTypes, navList)
        if (updatedNavList.length === 1) {
            //This logic to expand the RootTemplate by default when we are in Root org
            updatedNavList[0].isOpen = true
        }
        setEntityTypes(updatedNavList)
    }, [navList])

    //updating isopen(to open sub template list) in main array, so. when update is happing from left side or right side. we can still show open templates.
    const updateIsOpen = (id: string, value: boolean) => {
        const updatedEntityTypes = updateValue(id, value, entityTypes)
        setEntityTypes(updatedEntityTypes)
    }

    function updateValue(id: string, value: boolean, arr: EntityType[]) {
        const gottenArr = JSON.parse(JSON.stringify(arr))

        for (const obj of gottenArr) {
            if (obj.id === id) {
                obj.isOpen = value
            }
            if (
                Array.isArray(obj.subEntityTypes) &&
                obj.subEntityTypes.length > 0
            ) {
                obj.subEntityTypes = updateValue(id, value, obj.subEntityTypes)
            }
        }

        return gottenArr
    }

    const reload = () => {
        dispatch(getEntities(orgId))
    }

    return (
        <Box
            style={{
                // maxWidth: `${maxContainerWidth}px`,
                width: '260px',
                minWidth: '260px',
                padding: '10px 10px 10px 0px',
                borderRight: '1px solid rgba(0, 0, 0, 0.15)',
                maxHeight: 'calc(100vh - 220px)',
                overflow: 'auto',
            }}
        >
            <ListOfEntities
                list={entityTypes}
                isMainLevel={true}
                reload={reload}
                updateIsOpen={updateIsOpen}
            />
        </Box>
    )
}

export default DTLeftPane
